export default {
  header: {
    searchPlaceholder: "Rechercher"
  },
  notifications: {
    title: "Notifications",
    upToDate: "Vous êtes tous à jour !",
    noActivity: "Vous n'avez aucune activité non lue ici."
  },
  settingsMenu: {
    title: "Paramètres",
    connections: "Service connexion",
    users: "Utilisateurs",
    teams: "Équipes",
    groups: "Groupes",
    permissions: "Permissions",
    devops: "Service DevOps",
    usage: "Utilisation & Quotas",
    subscription: "Abonnement"
  },
  helpMenu: {
    title: "Aide",
    documentation: "Documentation",
    shortcuts: "Raccourcis clavier",
    tutorials: "Tutoriels vidéo",
    gettingStarted: "Guide de démarrage",
    support: "Support / Contact",
    about: "À propos"
  },
  userMenu: {
    title: "Mon profil",
    defaultName: "Utilisateur",
    role: "Rôle :",
    organization: "Organisation :",
    myAccount: "Mon compte",
    logout: "Déconnexion"
  },
  workspacePanel: {
    title: "Espaces de travail",
    searchPlaceholder: "Rechercher un projet",
    noProjects: "Aucun projet sauvegardé.",
    newWorkspace: "Nouvel espace de travail"
  },
  hero: {
    title: "Bienvenue sur GenIaC",
    subtitle: "Concevez, générez et déployez votre infrastructure cloud en quelques clics",
    startNow: "Commencer maintenant",
    exploreTemplates: "Explorer les templates"
  },
  stats: {
    architecturesCreated: "Architectures créées",
    resourcesDeployed: "Ressources déployées",
    savingsRealized: "Économies réalisées",
    activeUsers: "Utilisateurs actifs"
  },
  workspaces: {
    title: "Mes espaces de travail",
    tabs: {
      recent: "Récent",
      favorites: "Favoris",
      myApps: "Mes applications",
      external: "À partir d'organisations externes"
    },
    searchPlaceholder: "Filtrer par mot clé",
    filters: "Filtres",
    table: {
      name: "Nom",
      type: "Type",
      opened: "Ouvert",
      location: "Emplacement",
      approval: "Approbation",
      confidentiality: "Confidentialité"
    },
    types: {
      workspace: "Espace de travail",
      report: "Rapport",
      architecture: "Architecture",
      template: "Template"
    },
    approval: {
      approved: "Approuvé",
      pending: "En attente"
    },
    confidentiality: {
      confidential: "Confidentiel",
      public: "Public"
    },
    timeAgo: {
      hours_one: "Il y a {{count}} heure",
      hours_other: "Il y a {{count}} heures",
      yesterday: "Hier",
      days_one: "Il y a {{count}} jour",
      days_other: "Il y a {{count}} jours",
      week: "Il y a 1 semaine"
    },
    noWorkspaces: "Aucun espace de travail trouvé",
    resultsCount: "{{count}} espace de travail affiché",
    resultsCount_plural: "{{count}} espaces de travail affichés"
  },
  quickActions: {
    title: "Actions rapides",
    createArchitecture: {
      title: "Créer une architecture",
      description: "Commencez avec un canvas vierge"
    },
    exploreTemplates: {
      title: "Explorer les templates",
      description: "{{count}} architectures préconfigurées"
    },
    viewProjects: {
      title: "Voir mes projets",
      description: "Accédez à vos architectures"
    },
    start: "Démarrer"
  },
  features: {
    title: "Fonctionnalités principales",
    multiCloud: {
      title: "Multi-Cloud",
      description: "Gérez Azure, AWS et GCP depuis une seule plateforme"
    },
    iac: {
      title: "Infrastructure as Code",
      description: "Générez automatiquement du Terraform et Bicep"
    },
    fastDeployment: {
      title: "Déploiement Rapide",
      description: "Déployez vos architectures en quelques clics"
    },
    security: {
      title: "Sécurité & Conformité",
      description: "Best practices et validation automatique"
    },
    learnMore: "En savoir plus"
  },
  cloudResources: {
    title: "Ressources Cloud disponibles",
    more: "+{{count}} autres",
    validationMessage: "Toutes les ressources sont validées et suivent les best practices de sécurité"
  },
  cta: {
    title: "Prêt à démarrer?",
    subtitle: "Créez votre première architecture cloud en moins de 5 minutes",
    button: "Créer ma première architecture"
  }
};
